import { Form, Formik, FormikProps } from 'formik';
import React, { PropsWithChildren } from 'react';

interface FormFactoryType {
  children: React.ReactNode;
  formRef: any;
  initialValues: Object;
  className?: string;
}

const FormFactory = ({ children, initialValues, formRef, className }: FormFactoryType) => {
  return (
    <Formik innerRef={formRef} initialValues={initialValues} onSubmit={(values, actions) => {}}>
      {(props: FormikProps<any>) => <Form className={` ${className}`}>{children}</Form>}
    </Formik>
  );
};

export default FormFactory;
